import React, { useEffect } from "react";

import { navigate } from "@reach/router";
import { connect, ConnectedProps } from "react-redux";

import { LoadingView } from "cuanto/components";
import { CartReduxState, cartActions } from "cuanto/features/Cart";
import SubscriptionPriceSelect from "cuanto/features/Catalogue/components/Subscription/SubscriptionPriceSelect";
import { captureMessage } from "cuanto/services/Sentry.web";
import NotFound from "cuanto/web-app/components/NotFound";

import useCatalogue from "../contexts/CatalogueContext";
import useCatalogueProduct from "../hooks/useCatalogueProduct";

type RouteProps = { username: string; short_uuid: string };

function CataloguePriceScreen({
  username,
  short_uuid,
  selectedPrice,
  selectPrice,
  clearSelectedPrice,
}: RouteProps & ReduxProps) {
  useEffect(() => {
    clearSelectedPrice();
  }, [clearSelectedPrice]);

  const { addToCartWithPrice } = useCatalogue();

  const { isLoading, product, prices, showPriceSavings, merchant } =
    useCatalogueProduct(username, short_uuid);

  function createCartAndNavigate() {
    if (!selectedPrice || !product) return;

    const { redirectTo } = addToCartWithPrice(product, selectedPrice);
    const shortUuid = (product.product_group_uuid || product.uuid).slice(-6);

    console.log("DEBUG", { shortUuid, short_uuid, redirectTo });

    switch (redirectTo) {
      case "prices":
        navigate(`/${username}/p/${shortUuid}/prices`);
        break;
      case "cart":
        navigate(`/${username}/cart`);
        break;
      case "catalogue":
        navigate(`/${username}`);
        break;
      default:
        captureMessage("Unhandled redirectTo value", {
          redirectTo,
          shortUuid,
          short_uuid,
          username,
        });
    }
  }

  if (isLoading) return <LoadingView />;

  if (!product) return <NotFound />;

  return (
    <SubscriptionPriceSelect
      merchant={merchant}
      subscription={product}
      prices={prices}
      selectedPrice={selectedPrice}
      selectPrice={selectPrice}
      savingsEnabled={showPriceSavings}
      onSelect={createCartAndNavigate}
    />
  );
}

const mapStateToProps = ({ cart }: { cart: CartReduxState }) => ({
  selectedPrice: cart.selectedPrice,
});

const mapDispatchToProps = {
  selectPrice: cartActions.selectPrice,
  clearSelectedPrice: cartActions.clearSelectedPrice,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(CataloguePriceScreen);
